<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="聊天记录">
        <div class="flex xs12">
          <va-data-table
              :fields="fields"
              :data="messages"
              :loading="loading"
              :total-pages="totalPage"
              @page-selected="listPrivateMessage"
              api-mode
          >

            <template slot="payload" slot-scope="props">
              <template v-if="getPayloadType(props.rowData.payload)==='text'">
                {{ formatPayload(props.rowData.payload) }}
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='audio'">
                <audio v-bind:src="formatPayload(props.rowData.payload).url"
                       controls="controls"></audio>
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='image'">
                <va-card
                    overlay
                    :image='formatPayload(props.rowData.payload).url'
                    class="va-card-image"
                    :image-alt="formatPayload(props.rowData.payload).name"
                />
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='file'">
                <a v-bind:href="formatPayload(props.rowData.payload).url"> {{
                    formatPayload(props.rowData.payload).name
                  }} </a>
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='video'">
                <video v-bind:src="formatPayload(props.rowData.payload).url"
                       controls="controls" height="200px"></video>
              </template>
            </template>

            <template slot="avatar" slot-scope="props">
              <va-avatar>
                <img :src="formatAvatar(props.rowData.avatar)">
              </va-avatar>
            </template>

            <template slot="time" slot-scope="props">
              {{ formatTime(props.rowData.time) }}
            </template>

          </va-data-table>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import groupApi from '../../api/group'
import {dateFormat} from '../../utils/common'
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      message: ['Required field'],
      groups: [],
      loading: true,
      next: 0,
      totalPage: 0,
      deleteModal: false,
      deleteId: null,
      pageNumber: 1,
      nickname: null,
      chatId: null,
      messages: []
    }
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:avatar',
        },
        {
          name: 'nick',
          title: '发言人',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:time',
          title: '发言时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:payload',
          title: '内容',
          width: '60%',
          dataClass: 'text-left',
          titleClass: 'text-center',
        }
      ]
    },
  },
  created() {
    const params = this.$route.params
    this.chatId = params.chatId
    this.listPrivateMessage()
  },
  methods: {
    formatPayload(payload) {
      let payloadJson = JSON.parse(payload)
      if (payloadJson.hasOwnProperty("text")) {
        return payloadJson.text
      } else if (payloadJson.hasOwnProperty("data")) {
        let data = JSON.parse(payloadJson.data)
        if (payloadJson.hasOwnProperty("description") && payloadJson.description === 'audio') {
          return {
            "url": data.remoteAudioUrl
          }
        }
        return {
          "url": data.url,
          "name": data.name
        }
      }
    },
    getPayloadType(payload) {
      let payloadJson = JSON.parse(payload)
      if (payloadJson.hasOwnProperty("text")) {
        return "text"
      } else if (payloadJson.hasOwnProperty("data")) {
        if (payloadJson.hasOwnProperty("description") && payloadJson.description === 'audio') {
          return payloadJson.description
        }
        let data = JSON.parse(payloadJson.data)
        return data.type
      }
    },
    formatAvatar(avatar) {
      return avatar + '?x-oss-process=style/avatar'
    },
    formatTime(time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    listPrivateMessage(pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
        chatId: this.chatId,
      }
      if (this.nickname != null) {
        data.nickname = this.nickname
      }
      groupApi.listPrivateMessage(data)
          .then(response => {
            console.log(response)
            this.messages = response.messages
            this.loading = false
          })
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') {
        this.nickname = null
      }
      this.listPrivateMessage()
    }, 400),
  },
}

</script>
